import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'component/Breadcrumb'

const SuggestionHeader = (props) => {
  const { translate, pageName } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: pageName },
    ]

    return <Breadcrumb steps={steps} />
  }

  return renderBreadcrumb()
}

SuggestionHeader.propTypes = {
  translate: PropTypes.func.isRequired,
  pageName: PropTypes.string,
}

export default SuggestionHeader
